export const endpoints = {
  externalUrlItem: 'externalUrl',
  languageOptions: 'externalUrl/language/options',
  excludableFields: 'externalUrl/fieldNodes'
};
